export default __webpack_public_path__ + "static/media/arrow_left.f0bc4d70.svg";